var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zj-startup"},[_c('div',{staticClass:"zj-startup-box"},[_c('el-progress',{attrs:{"percentage":_vm.percent,"show-text":false}}),_c('p',[_vm._v(_vm._s(_vm.msg))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }